import React from "react";
import PropTypes from "prop-types";

import { Alert, AlertTitle, Button } from "@mui/material";

import RestrictedComponent from "../../../../lib/components/form/RestrictedComponent";
import schema from "../../../../routes/permissions/schema";

const NoKeywordsAlert = ({ toggleCreateModal }) => {
  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      <AlertTitle variant="h5">No keywords have been created yet</AlertTitle>

      <RestrictedComponent
        permissionCheck={schema.MANAGE_CLIENT_KEYWORDS.CREATE}
      >
        <Button variant="outlined" color="info" onClick={toggleCreateModal}>
          Create Keyword
        </Button>
      </RestrictedComponent>
    </Alert>
  );
};

NoKeywordsAlert.propTypes = {
  toggleCreateModal: PropTypes.func.isRequired,
};

export default NoKeywordsAlert;
